import env from "../utils/env";

/* on click of the reactivate button, the user (based on segment) will either see a pop-up 
or be redirected to /reactivate-my-membership */
export const showReactivatePopUpOrPage = (flag) => {
    let userSegment = Number(window.fffuser.usersegment);

    if (flag) {
        if (userSegment === 0 || userSegment === 2) {
            showPopupContent();
        } else if (userSegment === 1 || userSegment === 3) {
            window.location = `${env.envURL}/reactivate-my-membership`
        } else {
            window.location = `${env.envURL}/reactivate-my-membership`
        }
    } else {
        showPopupContent();
    }
}

const showPopupContent = () => {
    const popup = document.querySelector(
        ".pum-content.popmake-content .not-for-expired"
    );

    if (popup) {
        popup.classList.remove("not-for-expired");
    }
}


// WEBPACK FOOTER //
// ./src/utils/abTestUtils.js